/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import { useDropzone } from "react-dropzone";
import "./PhotoUploader.scss";

interface PhotoUploaderProps {
  /** Function to be called when files are added to the uploader. */
  onDrop: (files: File[]) => void;
  /** Props if multiple files are optional for uploading */
  multiple?: boolean;
}

/** Reusable component for uploading photos. */
export function PhotoUploader({ onDrop }: PhotoUploaderProps): JSX.Element {
  const { getRootProps, getInputProps, isDragActive, acceptedFiles } = useDropzone({
    accept: "image/*",
    multiple: false,
    onDrop,
  });
  return (
    <div className="photo-uploader">
      <div {...getRootProps()} className={`dropzone${isDragActive ? " drag" : ""}`}>
        <input {...getInputProps()} />
        {acceptedFiles.length === 0 ? (
          <span>Drop file here, or click to browse files.</span>
        ) : (
          <span>
            <i className="fas fa-file-image mr-2" />
            {acceptedFiles[0].name}
          </span>
        )}
      </div>
    </div>
  );
}

/** Reusable component for uploading multiple photos. */
export function MultiplePhotoUploader({ onDrop }: PhotoUploaderProps): JSX.Element {
  const { getRootProps, getInputProps, isDragActive, acceptedFiles } = useDropzone({
    accept: "image/*",
    multiple: true, // accept multiple input of images
    onDrop,
  });
  return (
    <div className="photo-uploader">
      <div {...getRootProps()} className={`dropzone${isDragActive ? " drag" : ""}`}>
        <input {...getInputProps()} />
        {acceptedFiles.length === 0 ? (
          <span>Drop file here, or click to browse files.</span>
        ) : (
          acceptedFiles.map(file => (
            <div style={{ display: "grid" }}>
              <i className="fas fa-file-image mr-2" />
              {file.name}
            </div>
          ))
        )}
      </div>
    </div>
  );
}
